import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'

const propTypes = {
  slice: PropTypes.object,
  linkResolver: PropTypes.func
}

class AwardSection extends Component {
  render() {
    let { 
      slice,
      linkResolver
    } = this.props
    const sp = slice.primary
    // console.log(slice)

    return (
      <section className="section-award">
        <div className="container">
          {PrismicReact.RichText.render(sp.section_title)}
          <div className="container-medium">
            {PrismicReact.RichText.render(sp.section_description)}
          </div>
          <ul className="flexbox">
            { 
              slice.items.map((item, index) => {
                return (
                  <li key={index} className={`flex-item ${ slice.items.length === 3 ? 'third' : slice.items.length === 2 ? 'half' : ''}`}>
                    <img src={item.award_icon.url} alt={PrismicReact.RichText.asText(item.award_title)}/>
                    {PrismicReact.RichText.render(item.award_title)}
                    {PrismicReact.RichText.render(item.award_description)}
                  </li>
                )
              })
            }
          </ul>
        </div>
      </section>
    )
  }
}

AwardSection.propTypes = propTypes

export default AwardSection


// WEBPACK FOOTER //
// ./src/components/Home/AwardSection.js